import type React from "react";
import { memo } from "react";

import { Icon } from "@components/Icon";

import {
  FavoriteIconWrapper,
  MarginBadgeContainer,
  MarginBadgeText,
  MarketCell,
  TokenIconSmall,
  TokenName,
} from "./styles";

interface MarketRowCellProps {
  baseSymbol: string;
  symbol: string;
  tokenIcon?: string;
  maxLeverage: string | number;
  isFavorite: boolean;
  marketAddr: string;
  onToggleFavorite: (address: string) => void;
}

// Memo - static cell content (icon, symbol, leverage) doesn't re-render on ticker updates
export const MarketRowCell = memo(
  ({ baseSymbol, symbol, tokenIcon, maxLeverage, isFavorite, marketAddr, onToggleFavorite }: MarketRowCellProps) => {
    const handleFavoriteClick = (e: React.MouseEvent) => {
      e.stopPropagation();
      onToggleFavorite(marketAddr);
    };

    const handleFavoriteTouchEnd = (e: React.TouchEvent) => {
      e.stopPropagation();
      e.preventDefault();
      onToggleFavorite(marketAddr);
    };

    return (
      <MarketCell>
        <FavoriteIconWrapper
          data-testid={`market-select:favorite:${baseSymbol}`}
          onClick={handleFavoriteClick}
          onTouchEnd={handleFavoriteTouchEnd}
        >
          <Icon
            color={isFavorite ? "yellow-strong" : "icon-secondary"}
            icon={isFavorite ? "ri-star-fill" : "ri-star-line"}
            size={16}
          />
        </FavoriteIconWrapper>
        {tokenIcon && <TokenIconSmall alt={symbol} src={tokenIcon} />}
        <TokenName>{baseSymbol}</TokenName>
        <MarginBadgeContainer>
          <MarginBadgeText>{`${maxLeverage}X`}</MarginBadgeText>
        </MarginBadgeContainer>
      </MarketCell>
    );
  },
);

MarketRowCell.displayName = "MarketRowCell";
